import React, { Component } from 'react';
import { connect } from 'react-redux';

import ContentCarousel from './content-carousel';
import { fetchRelatedBlogs } from '../../blog-list-actions';

const PRIORITY_TAGS_LENGTH_MIN = 5;

class ContentCarouselContainer extends Component {
    constructor(props) {
        super(props);
        this.filters = { templateKey: 'blog', hosted: 'true', blogArchive: 'false' };
        this.sort = { viewCount: 'desc' };
        this.size = 15;
        this.aggregates = {};
        this.aggregateFilters = [];
        this.bucketSize = 15;
        this.postFilters = {};
        this.from = 0;
    }

    componentDidMount() {
        const { tags, relatedBlogs } = this.props;
        const postFilters = { tags: tags.slice(0, PRIORITY_TAGS_LENGTH_MIN) };
        if (relatedBlogs && relatedBlogs.length === 0) {
            this.props.fetchRelatedBlogs(
                this.filters,
                postFilters,
                this.aggregates,
                this.aggregateFilters,
                this.sort,
                this.size,
                this.from,
                this.bucketSize
            );
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const prevTags = prevProps.tags.join('');
        const currentTags = this.props.tags.join('');

        const prevRelatedArticlesLength =
            prevProps.relatedBlogs && prevProps.relatedBlogs.hits ? prevProps.relatedBlogs.hits.hits.length : 0;
        const currentRelatedArticlesLength =
            this.props.relatedBlogs && this.props.relatedBlogs.hits ? this.props.relatedBlogs.hits.hits.length : 0;
        const { tags } = this.props;

        if (prevTags !== currentTags) {
            const postFilters = { tags: tags.slice(0, PRIORITY_TAGS_LENGTH_MIN) };
            this.props.fetchRelatedBlogs(
                this.filters,
                postFilters,
                this.aggregates,
                this.aggregateFilters,
                this.sort,
                this.size,
                this.from,
                this.bucketSize
            );
        }
        //If not enough related blogs come back (should not happen if orig limit is reasonable), make second call and increase limit
        else if (prevRelatedArticlesLength !== currentRelatedArticlesLength && currentRelatedArticlesLength < 15) {
            const postFilters = { tags };
            this.props.fetchRelatedBlogs(
                this.filters,
                postFilters,
                this.aggregates,
                this.aggregateFilters,
                this.sort,
                this.size,
                this.from,
                this.bucketSize
            );
        }
    }

    render() {
        const { header, relatedBlogs = {}, templateKey, isVisId } = this.props;

        return (
            <div>
                {typeof relatedBlogs === 'object' && Object.keys(relatedBlogs).length > 0 && (
                    <ContentCarousel
                        relatedBlogs={relatedBlogs}
                        header={header}
                        templateKey={templateKey}
                        visId={isVisId}
                    />
                )}
            </div>
        );
    }
}

const mapDispatchToProps = dispatch => {
    return {
        fetchRelatedBlogs: (filters, post_filters, aggregates, aggregateFilters, sort, size, from, bucketSize) =>
            dispatch(
                fetchRelatedBlogs(filters, post_filters, aggregates, aggregateFilters, sort, size, from, bucketSize)
            ),
    };
};

const mapStateToProps = (state, ownProps) => {
    return {
        relatedBlogs: state.blogListInfo.relatedBlogs,
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ContentCarouselContainer);
